import React from 'react';
import Modal from 'react-modal';
import './IntermediaryDetailsModal.css';

const formatCurrency = (value) => {
    if (value === null || value === undefined || value === '') {
        return '-';
    }

    const numericValue = Number(String(value).replace(',', '.'));

    if (Number.isNaN(numericValue)) {
        return '-';
    }

    return numericValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
    });
};

const formatStatus = (status) => {
    if (!status) {
        return 'AGUARDANDO';
    }

    return String(status)
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return '-';
    }

    return value;
};

const getIntermediaryName = (acquisition) => {
    if (!acquisition) {
        return '-';
    }

    return acquisition.doc_type === 'CNPJ'
        ? acquisition.bussiness_name
        : acquisition.name;
};

export default function IntermediaryDetailsModal({ acquisition, onClose }) {
    if (!acquisition) {
        return null;
    }

    Modal.setAppElement('#root');

    const document = acquisition.doc_type === 'CNPJ'
        ? acquisition.cnpj_number
        : acquisition.cpf_number;

    return (
        <Modal
            isOpen={Boolean(acquisition)}
            onRequestClose={onClose}
            contentLabel="Detalhes da intermediação"
            className="intermediary-details-modal"
            shouldCloseOnOverlayClick={true}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000,
                },
                content: {
                    zIndex: 1001,
                },
            }}
        >
            <div className='intermediary-details-header'>
                <div>
                    <span>Lançamento #{acquisition.id}</span>
                    <h2>{displayValue(getIntermediaryName(acquisition))}</h2>
                </div>
                <button type='button' onClick={onClose}>X</button>
            </div>

            <div className='intermediary-details-body'>
                {acquisition.doc_type === 'CNPJ' ? (
                    <>
                        <DetailSection title='Dados CNPJ'>
                            <DetailField label='Tipo de documento' value={acquisition.doc_type} />
                            <DetailField label='CNPJ' value={document} />
                            <DetailField label='Razão social' value={acquisition.bussiness_name} wide={true} />
                            <DetailField label='Status' value={formatStatus(acquisition.status)} />
                        </DetailSection>

                        <DetailSection title='Endereço CNPJ'>
                            <DetailField label='CEP' value={acquisition.cnpj_address_cep} />
                            <DetailField label='Rua' value={acquisition.cnpj_address_street} wide={true} />
                            <DetailField label='Número' value={acquisition.cnpj_address_number} />
                            <DetailField label='Complemento' value={acquisition.cnpj_address_complement} />
                            <DetailField label='Bairro' value={acquisition.cnpj_address_neighborhood} />
                            <DetailField label='Cidade' value={acquisition.cnpj_address_city} />
                            <DetailField label='Estado' value={acquisition.cnpj_address_state} />
                        </DetailSection>

                        <DetailSection title='Dados Representante'>
                            <DetailField label='Nome' value={acquisition.name} wide={true} />
                            <DetailField label='CPF' value={acquisition.cpf_number} />
                            <DetailField label='Telefone' value={acquisition.phone_number} />
                            <DetailField label='Nacionalidade' value={acquisition.nationality} />
                            <DetailField label='Estado civil' value={acquisition.marital_status} />
                            <DetailField label='Profissão' value={acquisition.occupation} />
                        </DetailSection>

                        <DetailSection title='Endereço Representante'>
                            <DetailField label='CEP' value={acquisition.address_cep} />
                            <DetailField label='Rua' value={acquisition.address_street} wide={true} />
                            <DetailField label='Número' value={acquisition.address_number} />
                            <DetailField label='Complemento' value={acquisition.address_complement} />
                            <DetailField label='Bairro' value={acquisition.address_neighborhood} />
                            <DetailField label='Cidade' value={acquisition.address_city} />
                            <DetailField label='Estado' value={acquisition.address_state} />
                        </DetailSection>
                    </>
                ) : (
                    <>
                        <DetailSection title='Cedente'>
                            <DetailField label='Tipo de documento' value={acquisition.doc_type} />
                            <DetailField label='Documento' value={document} />
                            <DetailField label='Nome' value={acquisition.name} wide={true} />
                            <DetailField label='Telefone' value={acquisition.phone} />
                            <DetailField label='Nacionalidade' value={acquisition.nationality} />
                            <DetailField label='Estado civil' value={acquisition.marital_status} />
                            <DetailField label='Profissão' value={acquisition.occupation} />
                            <DetailField label='Status' value={formatStatus(acquisition.status)} />
                        </DetailSection>

                        <DetailSection title='Endereço'>
                            <DetailField label='CEP' value={acquisition.address_cep} />
                            <DetailField label='Rua' value={acquisition.address_street} wide={true} />
                            <DetailField label='Número' value={acquisition.address_number} />
                            <DetailField label='Complemento' value={acquisition.address_complement} />
                            <DetailField label='Bairro' value={acquisition.address_neighborhood} />
                            <DetailField label='Cidade' value={acquisition.address_city} />
                            <DetailField label='Estado' value={acquisition.address_state} />
                        </DetailSection>
                    </>
                )}
                <DetailSection title='Dados bancários'>
                    <DetailField label='Banco' value={acquisition.bank_name} />
                    <DetailField label='Agência' value={acquisition.bank_account_agency} />
                    <DetailField label='Conta' value={acquisition.bank_account_number} />
                    <DetailField label='Tipo de conta' value={acquisition.bank_account_type} />
                    <DetailField label='Titular' value={acquisition.bank_account_name} />
                    <DetailField label='Documento titular' value={acquisition.bank_account_doc_number} />
                    <DetailField label='Tipo chave Pix' value={acquisition.key_pix_type} />
                    <DetailField label='Pix' value={acquisition.key_pix} />
                </DetailSection>

                <DetailSection title='Administradora'>
                    <DetailField label='Administradora' value={acquisition.consortium_agency?.name || acquisition.consortium_agency_name || acquisition.consortium_agency_id} />
                    <DetailField label='CNPJ' value={acquisition.consortium_agency?.cnpj || acquisition.consortium_agency_cnpj} />
                    <DetailField label='CEP' value={acquisition.consortium_agency?.zipCode || acquisition.consortium_agency_zipcode} />
                    <DetailField label='Rua' value={acquisition.consortium_agency?.address || acquisition.consortium_agency_address} wide={true} />
                    <DetailField label='Número' value={acquisition.consortium_agency?.number || acquisition.consortium_agency_number} />
                    <DetailField label='Bairro' value={acquisition.consortium_agency?.neighborhood || acquisition.consortium_agency_neighborhood} />
                    <DetailField label='Cidade' value={acquisition.consortium_agency?.city || acquisition.consortium_agency_city} />
                    <DetailField label='Estado' value={acquisition.consortium_agency?.state || acquisition.consortium_agency_state} />
                </DetailSection>

                <DetailSection title='Cartório e cessão'>
                    <DetailField label='Cidade cartório' value={acquisition.registry_city} />
                    <DetailField label='Valor da cessão' value={formatCurrency(acquisition.customer_value)} />
                    <DetailField label='Reconhecimento de firma' value={acquisition.check_firma === 'S' ? 'Sim' : 'Não'} />
                </DetailSection>

                <section className='intermediary-details-section'>
                    <h3>Cotas</h3>
                    {acquisition.quotas?.length ? (
                        <div className='intermediary-details-quotas'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Grupo</th>
                                        <th>Cota</th>
                                        <th>Contrato</th>
                                        <th>Crédito</th>
                                        <th>% pago</th>
                                        <th>Recebível</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {acquisition.quotas.map((quota) => (
                                        <tr key={quota.id}>
                                            <td>{displayValue(quota.group_number)}</td>
                                            <td>{displayValue(quota.quota_number)}</td>
                                            <td>{displayValue(quota.contract_number)}</td>
                                            <td>{formatCurrency(quota.credit_value)}</td>
                                            <td>{displayValue(quota.paid_percentage_value)}</td>
                                            <td>{formatCurrency(quota.receivable_value)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <span className='intermediary-details-empty'>Nenhuma cota cadastrada.</span>
                    )}
                </section>
            </div>
        </Modal>
    );
}

function DetailSection({ title, children }) {
    return (
        <section className='intermediary-details-section'>
            <h3>{title}</h3>
            <div className='intermediary-details-grid'>{children}</div>
        </section>
    );
}

function DetailField({ label, value, wide = false }) {
    return (
        <div className={`intermediary-details-field ${wide ? 'intermediary-details-field-wide' : ''}`}>
            <span>{label}</span>
            <strong>{displayValue(value)}</strong>
        </div>
    );
}
